var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppissueA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4738 0.938965H2.52305C1.4808 0.938965 0.629883 1.78994 0.629883 2.83218V20.1545C0.629883 21.2 1.48086 22.0476 2.52305 22.0476H12.4738C13.5194 22.0476 14.3703 21.2 14.3703 20.1545V2.83218C14.3703 1.78994 13.5194 0.938965 12.4738 0.938965ZM13.7106 18.6142H1.28948V2.83218C1.28948 2.15275 1.84356 1.59862 2.52305 1.59862H4.19525L5.22431 3.26423C5.28696 3.35989 5.39254 3.41922 5.50797 3.41922H9.49553C9.61097 3.41922 9.71649 3.35984 9.77587 3.26423L10.8049 1.59862H12.4738C13.1566 1.59862 13.7106 2.15275 13.7106 2.83218V18.6142Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5444 14.5805C10.4421 14.6794 10.2872 14.7025 10.1618 14.6333L7.50014 13.2183L4.84175 14.6332C4.71313 14.7025 4.55809 14.6794 4.45584 14.5804C4.35358 14.4782 4.32722 14.3265 4.38987 14.1979L7.20657 8.49853C7.31541 8.27425 7.68481 8.27425 7.79693 8.49853L10.6103 14.1979C10.6763 14.3265 10.6466 14.4782 10.5444 14.5805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppissueA);
export default __webpack_public_path__ + "static/media/appissueA.e7031e6a50d1d49c8e36b20107bb5c54.svg";
export { ForwardRef as ReactComponent };